// Module
var code = "<div id=\"V-0B7C9E2E-4C50-4C7A-9800-4962251EA4F4\"> <div data-b-class-divimageelement=\"{Static true}\" data-b-style-background-image=\"{Binding Source}\" data-b-attr-class=\"{Binding Class}\" data-b-attr-style=\"{Binding Style}\"></div> </div> ";
// Exports
export default code;